<template lang="pug">

.breadcrumbs-container(v-if="$route.name !== 'main'")
  .breadcrumbs-content
    .custom-breadcrumbs
      .breadcrumb-wrapper(
        v-for="(item, index) in itemsList"
        :key="index"
      )
        router-link.breadcrumb-item(
          v-if="item.to"
          :to="item.to"
          :class="{ active: !item.to || index === itemsList.length - 1 }"
        )
          v-icon.mr-1(v-if="item.icon" size="16") {{ item.icon }}
          | {{ item.text }}
        span.breadcrumb-item(
          v-else
          :class="{ static: true }"
        )
          v-icon.mr-1(v-if="item.icon" size="16") {{ item.icon }}
          | {{ item.text }}
        span.breadcrumb-divider(
          v-if="index < itemsList.length - 1"
        ) /

</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Breadcrumbs',

  computed: {
    ...mapState('breadcrumbs', ['items']),

    itemsList() {
      return [
        {
          text: 'Расписание занятий',
          exact: true,
          to: { name: 'main', params: this.$route.params },
          icon: 'mdi-home',
        },
      ].concat(this.items)
    },
  },
}
</script>

<style lang="sass" scoped>

.breadcrumbs-container
  background: #f8fafc

.breadcrumbs-content
  max-width: 1200px
  margin: 0 auto
  padding: 12px 24px
  width: 100%

.custom-breadcrumbs
  display: flex
  align-items: center
  flex-wrap: wrap
  font-size: 14px
  transform: translateX(-6px)
  line-height: 1.4

.breadcrumb-wrapper
  display: flex
  align-items: center
  margin-bottom: 4px

.breadcrumb-item
  display: flex
  align-items: center
  color: #666
  font-weight: 500
  text-decoration: none
  transition: all 0.3s ease
  padding: 4px 8px
  border-radius: 6px
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

  // Hover only for devices with mouse
  @media (hover: hover)
    &:hover:not(.active):not(.static)
      background: rgba(59, 130, 246, 0.1)
      color: #3b82f6

  &.static
    color: #666
    font-weight: 500
    cursor: default

    .v-icon
      color: #666

  &.active
    color: #3b82f6
    font-weight: 600
    cursor: default

    .v-icon
      color: #3b82f6

.breadcrumb-divider
  color: #bbb
  margin: 0 8px
  user-select: none

// Responsive
@media (max-width: 768px)
  .breadcrumbs-content
    padding: 8px 16px

  .custom-breadcrumbs
    font-size: 13px
    gap: 2px

  .breadcrumb-divider
    margin: 0 6px

@media (max-width: 480px)
  .breadcrumbs-content
    padding: 8px 20px

  .custom-breadcrumbs
    font-size: 12px
    gap: 2px

  .breadcrumb-item
    padding: 3px 6px

  .breadcrumb-divider
    margin: 0 4px
</style>
